<template>
  <div class="motorsport-calendar-page">
    <header-pane
      class="motorsport-calendar-page__header"
      colorType="light"
      :pageTitle="$tc('LinkPage.pageTitle')"
      navigationCurrent="link"
      :hasHeaderNav="hasHeaderNav"
    />
    <sub-header-section
      :pageTitle="$tc('LinkPage.MotorsportCalendarPage.pageTitle')"
      :execTransitionEventParent="true"
      @onClick="backToPreviousPage"
    />

    <calendar-pane />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import HeaderPane from '@/components/common/Header/HeaderPane.vue'
import CalendarPane from '@/components/LinkPage/CalendarPane.vue'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'

export default defineComponent({
  name: 'MotorsportCalendar',
  components: {
    SubHeaderSection,
    HeaderPane,
    CalendarPane,
  },
  props: {
    /**
     * ヘッダーナビ表示指定
     */
    hasHeaderNav: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    /**
     * 前のページに遷移する
     */
    backToPreviousPage() {
      return this.$router.back()
    },
  },
})
</script>

<style lang="scss" scoped>
.motorsport-calendar-page {
  background: $gray1;
  min-height: var(--screen-height);
  padding-bottom: var(--safe-area-inset-bottom);
}
</style>
